// import { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Checkbox, IconButton, Tooltip } from '@mui/material'

import SendIcon from '../../assets/icons/send-icon.svg'
import TrashIcon from '../../assets/icons/trash-icon.svg'
import { SystemUser, UserSessionType } from '../../types'
import AccountIcon from '../../assets/icons/account-icon.svg'
import DocumentIcon from '../../assets/icons/document-icon.svg'
import ArrowRightIcon from '../../assets/icons/arrow-right-icon.svg'

const SystemUserDataListItem = ({
  userSession,
  systemUserData,
  handleToggleSystemUserSelection,
  handleResendSystemUserInvitation,
  handleOpenDeleteSystemUserDataModal,
  handleOpenUpdateSystemUserDataModal
}: {
  systemUserData: SystemUser
  userSession: UserSessionType
  handleResendSystemUserInvitation: (selectedSystemUserData: SystemUser) => void
  handleOpenDeleteSystemUserDataModal: (selectedSystemUserData: SystemUser) => void
  handleOpenUpdateSystemUserDataModal: (selectedSystemUserData: SystemUser) => void
  handleToggleSystemUserSelection: (selectedSystemUserData: SystemUser, selected: boolean) => void
}) => {
  const { t } = useTranslation(['system-users-management'])

  return (
    <div
      onClick={() => handleOpenUpdateSystemUserDataModal(systemUserData)}
      className="users-management-user-data-container"
    >
      <div className="users-table-column users-table-width-35">
        <Checkbox
          checked={systemUserData.selected ?? false}
          onClick={(event) => event.stopPropagation()}
          onChange={(event) => {
            handleToggleSystemUserSelection(systemUserData, event.target.checked)
          }}
        />
        <div className="users-management-user-image-profile">
          <img
            src={AccountIcon}
            alt="account-icon"
          />
        </div>
        <div className="users-management-user-name-profile">{`${systemUserData?.firstName?.toUpperCase()} ${systemUserData?.lastName?.toUpperCase()}`}</div>
      </div>
      <div className="users-table-column users-table-width-35 display-none-inter display-none-sm">
        <div className="users-management-user-image-profile">
          <img
            src={DocumentIcon}
            alt="document-icon"
          />
        </div>
        <div className="users-management-user-name-profile">{systemUserData?.description ? systemUserData?.description.replace(/\n/g, ' ') : '-'}</div>
      </div>
      <div className="users-table-column users-table-width-25">
        <div className="users-table-column users-table-width-40 display-none-md">
          {systemUserData?.role === 'admin' || (userSession?.role.indexOf('-client') > -1 && systemUserData?.role === 'admin-client')
            ? t('userRoles.administrator')
            : systemUserData?.role === 'admin-client' || systemUserData?.role === 'super-admin-client'
            ? t('userRoles.clientAdmin')
            : systemUserData?.role === 'admin-client-builder' && userSession?.role.indexOf('-client') === -1
            ? t('userRoles.clientBuilder')
            : t('userRoles.builder')}
        </div>
        <div
          className="users-table-column users-table-width-30 display-none-bg"
          style={{ color: systemUserData?.activated ? '#22C55E' : '#EF4444' }}
        >
          {systemUserData?.activated ? t('userStatus.active') : t('userStatus.inactive')}
        </div>
        <div className="users-table-column users-table-width-30">
          <IconButton
            edge="end"
            sx={{ color: '#107569' }}
            onClick={(event) => {
              event.stopPropagation()
              handleOpenDeleteSystemUserDataModal(systemUserData)
            }}
            aria-label="toggle password visibility"
          >
            <img
              src={TrashIcon}
              alt="trash-icon"
            />
          </IconButton>
          {systemUserData?.activated === false && (
            <Tooltip
              title={t('tooltips.resendActivationEmail')}
              placement="top"
            >
              <IconButton
                edge="end"
                sx={{ color: '#107569' }}
                onClick={(event) => {
                  event.stopPropagation()
                  handleResendSystemUserInvitation(systemUserData)
                }}
                aria-label="toggle password visibility"
              >
                <img
                  src={SendIcon}
                  alt="send-icon"
                />
              </IconButton>
            </Tooltip>
          )}
          <div className="users-management-user-data-arrow-right">
            <img
              src={ArrowRightIcon}
              alt="arrow-right-icon"
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default SystemUserDataListItem
